import './App.css';
import Banner from './components/Banner';
import About from './components/About';
import Explore from './components/Explore';
import Team from './components/Team';
import Footer from './components/Footer';
import Packages from './components/Packages';
import InstagramFloatingIcon from './components/InstagramFloatingIcon';
import Trainers from './components/Trainers';
function App() {
  return (
    <div className="App">
      {/* <Header /> */}
      <Banner />
      <About />
      <Trainers />
      <Packages />

      <Explore />
      <Team />
      <InstagramFloatingIcon />
      <Footer />
    </div>
  );
}

export default App;
